/* eslint-disable security/detect-possible-timing-attacks */
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { AppState } from '~/state/store'

import ROUTES from '~/constants/routes'
import { STORAGE } from '~/constants/storage'

export enum Auth {
  Shared = 'SHARED',
  Authorized = 'AUTHORIZED',
  Unauthorized = 'UNAUTHORIZED'
}

type Options = {
  auth?: Auth
  access?: RolesUnion
  verify?: (user: Partial<User>) => boolean
}

const withAuth = (options?: Options) => (Page: NextPage) => (): JSX.Element => {
  const { push } = useRouter()

  const user = useSelector<AppState, Partial<User>>((state) => state.user)

  useEffect(() => {
    const { auth = Auth.Shared, access, verify } = options || {}
    const { token, confirmed, email, role } = user

    let redirect = ''

    if (auth === Auth.Unauthorized) {
      if (verify) {
        if (verify(user)) redirect = ROUTES.dashboard
      } else if (!!token && confirmed) {
        redirect = ROUTES.dashboard
      }
    } else if (auth === Auth.Authorized) {
      if (verify) {
        if (verify(user)) redirect = ROUTES.auth.signIn
      } else if (!!token && !confirmed) {
        localStorage.setItem(STORAGE.userEmail, email)

        redirect = ROUTES.auth.verify
      } else if (access) {
        if (!(access === role && !!token && confirmed)) {
          redirect = ROUTES.auth.signIn
        }
      } else if (!(!!token && confirmed)) {
        redirect = ROUTES.auth.signIn
      }
    }

    if (redirect) push(redirect)
  }, [user])

  return <Page />
}

export default withAuth
